<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
            <li><a href="#">首页</a></li>
            <li><a href="#">短信</a></li>
            <li><a href="#">号码设置</a></li>
            </ul>
        </div>
    
        <div id="usual1" class="usual">  
  	        <div class="formbody">    
                <div class="formtitle"><span>号码设置</span></div>    
                <ul class="forminfo">    
                    <li><label>移动号码</label>
                        <input name="" type="text" v-model="mobilenum" class="dfinput left maringht10" />
                        <div @click="checknum('mobile')" class="buttonupload  click">修改并验证</div>
                    </li>
                    <li><label>办公号码</label>
                    <input name="" type="text" v-model="officenum" class="dfinput left maringht10" /><div @click="checknum('office')" class="buttonupload  click">修改并验证</div>
                    </li>
                    <li><label>家庭号码</label>
                    <input name="" type="text" v-model="homenum" class="dfinput left maringht10" /><div @click="checknum('home')" class="buttonupload  click">修改并验证</div>
                    </li>
                </ul>
    
                <div class="jian">&nbsp;</div>
                <div class="welinfo">
                    <span><img src="../../assets/images/dp.png" alt="验证步骤" /></span>
                    <b>验证步骤</b>
                </div>
    
                <ul class="infolist">
                    <li><span class="ea2020">	请确认您在要验证的电话旁边，可以接听该电话 </span></li>
                    <li><span>1、填写号码，提交 （固话和小灵通前请加区号） </span></li> 
                    <li><span>2、电话振铃，接听，记录验证码，挂电话</span></li> 
                    <li><span>3、填写听到的验证码，再次提交</span></li>
                </ul>
            </div> 
    
	    </div> 
        <div class="tip" style="height:200px;">
    	    <div class="tiptop"><span>号码验证</span><a></a></div>
        
            <div class="tipinfo" style="height:60px;">
                验证码：<input name="" v-model="verifyCode" type="text" class="scinput" style="width:200px;"/>
                
            </div>
        
            <div class="tipbtn">
                <input name="" type="button"  class="sure" @click="checkcode()" value="确定" />&nbsp;
                <input name="" type="button"  class="cancel" @click="close()" value="取消" />
            </div>    
        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            mobilenum:'',
            officenum:'',
            homenum:'',
            checkmodel:'',
            verifyCode:'',
        }
    },
    mounted(){
        this.getData();
    },
    methods:{
        getData(){
            let that = this
            let data = {}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/dialphone/mohnum.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    //console.log(res.data.enterprise);
                    that.mobilenum = res.data.mohNum.mobilenum;
                    that.officenum = res.data.mohNum.officenum;
                    that.homenum = res.data.mohNum.homenum;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        checknum(checkmodel){
            this.checkmodel = checkmodel;
            var mobile = this.mobilenum;
            if(checkmodel == 'mobile')
                mobile = this.mobilenum;
            else if(checkmodel == 'office')
                mobile = this.officenum;
            else if(checkmodel == 'home')
                mobile = this.homenum;
            let that = this
            let data = {'mobile': mobile, 'checkModel': checkmodel};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/dialphone/sendmohcode.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("设置成功！");
                }
                else if('0050005' == res.data.code){
                    $(".tip").fadeIn(200);
                    $(".tiptop a").click(function(){
                        $(".tip").fadeOut(200);
                    })
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        close(){
            $(".tip").fadeOut(200);
        },
        checkcode(){
            if(this.verifyCode.trim() == ''){
                alert("验证码不能为空！");
                return;
            }
            let that = this
            let data = {'verifyCode': this.verifyCode, 'verifyType': this.checkmodel};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/dialphone/checkmohcode.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    alert("设置成功！");
                    that.close();
                    that.getData();
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/dial/dialset.vue